import Module from "./Module";
import WAStatusList from "./views/WAStatusList";
import WAStatusAktif from "./views/WAStatusAktif";
import WARiwayatStatus from "./views/WARiwayatStatus";
import CreateStatus from "./views/CreateStatus";
import WAStatusDetail from "./views/WAStatusDetail";

const requireAuth = { requireAuth: true };

const moduleRoute = {
    path: "/wa-status",
    component: Module,
    children: [
        {
            path: "",
            component: Module,
            children: [
                {
                    path: "index/:deviceId?",
                    name: "wa_status.list",
                    component: WAStatusList,
                    meta: requireAuth,
                },
                {
                    path: "pilih-perangkat",
                    name: "wa_status.pilih_perangkat",
                    components: {
                        default: WAStatusList,
                        dialog: () => {
                            return import("./components/modals/PilihPerangkat.vue");
                        },
                    },
                },
                {
                    path: "sedang-tayang",
                    name: "wa_status.sedang_tayang",
                    components: {
                        default: WAStatusList,
                        dialog: () => {
                            return import("./components/modals/SedangTayang.vue");
                        },
                    },
                },
                {
                    path: "confirm-akhiri-penayangan",
                    name: "wa_status.confirm_akhiri_penayangan",
                    components: {
                        default: WAStatusList,
                        dialog: () => {
                            return import("./components/modals/AkhiriPenayangan.vue");
                        },
                    },
                },
                {
                    path: "terjadwal",
                    name: "wa_status.terjadwal",
                    components: {
                        default: WAStatusList,
                        dialog: () => {
                            return import("./components/modals/Terjadwal.vue");
                        },
                    },
                },
                {
                    path: "confirm-hapus",
                    name: "wa_status.confirm_hapus",
                    components: {
                        default: WAStatusList,
                        dialog: () => {
                            return import("./components/modals/HapusTerjadwal.vue");
                        },
                    },
                },
                {
                    path: "diposting",
                    name: "wa_status.diposting",
                    components: {
                        default: WAStatusList,
                        dialog: () => {
                            return import("./components/modals/Diposting.vue");
                        },
                    },
                },
                {
                    path: "gagal-posting",
                    name: "wa_status.gagal_posting",
                    components: {
                        default: WAStatusList,
                        dialog: () => {
                            return import("./components/modals/GagalPosting.vue");
                        },
                    },
                },
                {
                    path: "detail-status",
                    name: "wa_status.detail_status",
                    component: WAStatusDetail,
                    meta: requireAuth,
                },
                {
                    path: "edit-status",
                    name: "wa_status.edit_status",
                    component: CreateStatus,
                    meta: requireAuth,
                },
            ],
        },
        {
            path: "create-status",
            component: Module,
            children: [
                {
                    path: "",
                    name: "wa_status.create_status",
                    component: CreateStatus,
                    meta: requireAuth,
                },
                {
                    path: "upload-modal",
                    name: "wa_status.create_status.upload_modal",
                    components: {
                        default: CreateStatus,
                        dialog: () => {
                            return import("./components/modals/UploadModal.vue");
                        },
                    },
                },
                {
                    path: "confirm-posting/:data",
                    name: "wa_status.create_status.confirm-posting",
                    components: {
                        default: CreateStatus,
                        dialog: () => {
                            return import("./components/modals/ConfirmPosting.vue");
                        },
                    },
                },
                {
                    path: "confirm-edit/:data",
                    name: "wa_status.create_status.confirm_edit",
                    components: {
                        default: CreateStatus,
                        dialog: () => {
                            return import("./components/modals/ConfirmEdit.vue");
                        },
                    },
                },
            ],
        },
        {
            path: "riwayat",
            component: Module,
            children: [
                {
                    path: "index/:iddevice?",
                    name: "wa_status.riwayat_status",
                    component: WARiwayatStatus,
                    meta: requireAuth,
                },
                {
                    path: "sedang-tayang",
                    name: "wa_status.riwayat_status.sedang_tayang",
                    components: {
                        default: WARiwayatStatus,
                        dialog: () => {
                            return import("./components/modals/SedangTayang.vue");
                        },
                    },
                },
                {
                    path: "confirm-akhiri-penayangan",
                    name: "wa_status.riwayat_status.confirm_akhiri_penayangan",
                    components: {
                        default: WARiwayatStatus,
                        dialog: () => {
                            return import("./components/modals/AkhiriPenayangan.vue");
                        },
                    },
                },
                {
                    path: "terjadwal",
                    name: "wa_status.riwayat_status.terjadwal",
                    components: {
                        default: WARiwayatStatus,
                        dialog: () => {
                            return import("./components/modals/Terjadwal.vue");
                        },
                    },
                },
                {
                    path: "confirm-hapus",
                    name: "wa_status.riwayat_status.confirm_hapus",
                    components: {
                        default: WARiwayatStatus,
                        dialog: () => {
                            return import("./components/modals/HapusTerjadwal.vue");
                        },
                    },
                },
                {
                    path: "diposting",
                    name: "wa_status.riwayat_status.diposting",
                    components: {
                        default: WARiwayatStatus,
                        dialog: () => {
                            return import("./components/modals/Diposting.vue");
                        },
                    },
                },
                {
                    path: "gagal-posting",
                    name: "wa_status.riwayat_status.gagal_posting",
                    components: {
                        default: WARiwayatStatus,
                        dialog: () => {
                            return import("./components/modals/GagalPosting.vue");
                        },
                    },
                },
            ],
        },
        {
            path: "aktif",
            component: Module,
            children: [
                {
                    path: "index/:aktif_id?",
                    name: "wa_status.status_aktif",
                    component: WAStatusAktif,
                    meta: requireAuth,
                },
                {
                    path: "sedang-tayang",
                    name: "wa_status.status_aktif.sedang_tayang",
                    components: {
                        default: WAStatusAktif,
                        dialog: () => {
                            return import("./components/modals/SedangTayang.vue");
                        },
                    },
                },
                {
                    path: "confirm-akhiri-penayangan",
                    name: "wa_status.status_aktif.confirm_akhiri_penayangan",
                    components: {
                        default: WAStatusAktif,
                        dialog: () => {
                            return import("./components/modals/AkhiriPenayangan.vue");
                        },
                    },
                },
                {
                    path: "terjadwal",
                    name: "wa_status.status_aktif.terjadwal",
                    components: {
                        default: WAStatusAktif,
                        dialog: () => {
                            return import("./components/modals/Terjadwal.vue");
                        },
                    },
                },
                {
                    path: "diposting",
                    name: "wa_status.status_aktif.diposting",
                    components: {
                        default: WAStatusAktif,
                        dialog: () => {
                            return import("./components/modals/Diposting.vue");
                        },
                    },
                },
                {
                    path: "gagal-posting",
                    name: "wa_status.status_aktif.gagal_posting",
                    components: {
                        default: WAStatusAktif,
                        dialog: () => {
                            return import("./components/modals/GagalPosting.vue");
                        },
                    },
                },
                {
                    path: "confirm-hapus",
                    name: "wa_status.status_aktif.confirm_hapus",
                    components: {
                        default: WAStatusAktif,
                        dialog: () => {
                            return import("./components/modals/HapusTerjadwal.vue");
                        },
                    },
                },
            ],
        },
    ],
};

export default (router) => {
    router.addRoutes([moduleRoute]);
};
